import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { utils } from '../../utils';
import { CustomFieldModel } from '../../types/customField';
import { EndpointResponse } from '../../types/endpoints';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  model: CustomFieldModel;
};

type Response = {
  count: number;
};

const validate = (model: CustomFieldModel) => {
  if (!model) {
    throw new Error('`model` is required');
  }
};

export const getCustomFieldsCount = async (
  scope: RequestScope,
  { model }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`${model}/fields/count`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
